module.exports = __webpack_public_path__ + "img/Beste.404d8089.svg";